import qs from 'qs';
import fetcher from '../../modules/ajio-fetch';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser,
  loginHostUrl
} from '../../modules/ajio-fetch/utils';
import { showLoader, hideLoader } from '../../actions/shared/loader';
import { showError, setErrorObject } from '../../actions/shared/HTTPError';
import { getCart, setNormalizedCartResponse } from '../../cart/actions/cart';
import { eraseCookie, readCookie } from '../../utils/Cookie';
import { setLayoutModalContent } from '../../actions/webMetaData';
import { showModal } from '../../actions/modal';
import properties from '../../modules/ajio-util/properties';
import { checkFingerPrintDetails } from '../../utils/fingerPrint.js';
import isNode from '../../modules/ajio-util/isNode.js';
import { addCleverTapUserLogin } from '../../modules/ajio-util/cleverTap/eventUtils';
import { createAnonymousToken } from '../../actions/authUser';
import { gtmEventPush, segmentEventPush } from '../../modules/ga/GTMdatalayer';
import { getLocaleData } from '../../actions/localeBannerApi/localeClientCall';
import { segmentTrackUser, segmentReset } from '../../modules/ga/segment/segment';
import { clearAmplitudeReferralProps, amplitudeLogout } from '../../modules/ga/segment/amplitude';
import { setCookie } from '../../refresh/utils/cookie';

const login_url = properties.getProperty('loginPageURL');

function setSignInResponse(userStatus) {
  return {
    type: 'SIGNIN_SUCCESS',
    validUser: true
  };
}

function setAccCheckResponse(userAccCheck, data) {
  return {
    type: 'ACC_CHECK_SUCCESS',
    userAccCheck,
    data
  };
}

function setGenerateLoginOTPResponse(otpObj) {
  return {
    type: 'SEND_LOGIN_OTP',
    otpSuccess: otpObj.success,
    otpResponseObj: otpObj
  };
}

function setNewPasswordResponse(resp) {
  return {
    type: 'SET_NEW_PASS',
    status: resp.status,
    desc: resp.desc
  };
}

function setSocialSignInResponse(res) {
  return {
    type: 'SOCIAL_AUTH',
    social: res
  };
}

function setUserInfo(res) {
  return {
    type: 'USER_INFO_CREATED',
    userName: res.userName,
    emailId: res.emailId,
    resetPasswordFirstLogin: res.resetPasswordFirstLogin
  };
}
function setGenerateCaptchaInfo(res) {
  return {
    type: 'CAPTCHA_GENERATED',
    res
  };
}
function updateMinicart(count = 0, entries) {
  return {
    type: 'UPDATE_MINI_CART',
    count,
    entries
  };
}

function setSSOCheckResponse(ssoData) {
  return {
    type: 'SSO_CHECK_RESPONSE',
    ssoData
  };
}

export function setCaptcha(captchaData) {
  return {
    type: 'ERR_SET_CAPTCHA',
    captchaData
  };
}

export function setSignupSocial(socialLoginInfo) {
  return {
    type: 'SIGNUP_SOCIAL_STATUS',
    socialLoginInfo
  };
}

export function postAccountCheck(postAccountCheckInfo) {
  return {
    type: 'POST_ACCOUNT_CHECK',
    postAccountCheckInfo
  };
}

export function setGoogleAuthUrl(googleAuthUrl) {
  return {
    type: 'GOOGLE_AUTH_URL',
    googleAuthUrl
  };
}

function hideError(dispatch) {
  let timeout = setTimeout(() => {
    dispatch(setErrorObject({}));
    clearTimeout(timeout);
  }, 2000);
}

function getCartForUser({ user = '', dispatch }) {
  if (user) {
    console.log('TRACK CART ISSUE In signinAction.js, getCartForUser Function, user', user);
    dispatch(showLoader('cart-loader'));
    return new Promise((resolve, reject) => {
      return fetcher(
        `/api/cart/${user}/getcart`,
        fetchGetJSONReqOpts({
          method: 'GET',
          headers: { 'content-type': 'application/json' },
          credentials: 'include'
        })
      )
        .then(fetchGetJSONResHandler)
        .then(response => {
          let { totalUnitCount: count = 0 } = response;
          let { cartItem = [] } = setNormalizedCartResponse({ response, dispatch, filterGiftItem: true });
          console.log(
            'TRACK CART ISSUE In signinAction.js, getCartForUser Function, response',
            response
          );
          dispatch(updateMinicart(count, cartItem));
          dispatch(hideLoader('cart-loader'));
          resolve(response);
        })
        .catch(err => {
          console.log('TRACK CART ISSUE In signinAction.js, getCartForUser Function, err', err);
          dispatch(hideLoader('cart-loader'));
          reject(err);
        });
    });
  }
}

export function accountCheck(data, callback) {
  return function (dispatch) {
    return checkFingerPrintDetails()
      .then(() => {
        dispatch(showLoader('auth-modal-loader'));
        const apiEndPoint = loginHostUrl(login_url, '/api/auth/accountCheck');
   
        return fetcher(
          apiEndPoint,
          fetchGetJSONReqOpts({
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'content-type': 'application/json' },
            credentials: 'include'
          })
        )
          .then(fetchGetJSONResHandler)
          .then(serviceRes => {
            dispatch(setAccCheckResponse(serviceRes, data));
            if (serviceRes.captchaInputRequired) dispatch(setCaptcha(serviceRes.captchaImage));
            dispatch(setUserInfo(serviceRes));
            dispatch(hideLoader('auth-modal-loader'));
            dispatch(setErrorObject({}));
            callback(serviceRes);
          })
          .catch(err => {
            let statusCode = getErrorStatusCode(err);
            errorParser(err, statusCode).then((errorObj = {}) => {
              errorObj.originator = 'login';
              dispatch(hideLoader('auth-modal-loader'));
              let messageBar = {
                errorType: 'info',
                pageType: 'login-info',
                message: 'oops! something went wrong, please try again..'
              };
              dispatch(setErrorObject(messageBar));
            });
          });
      })
      .catch(err => {
        let messageBar = {
          errorType: 'info',
          pageType: 'login-info',
          message: 'oops! something went wrong, please try again...'
        };
        dispatch(setErrorObject(messageBar));
      });
  };
}

export function refreshCaptcha(data, callback) {
  return function (dispatch) {
    return checkFingerPrintDetails()
      .then(() => {
        dispatch(showLoader('auth-modal-loader'));
        const apiEndPoint = loginHostUrl(login_url, '/api/auth/login');
        console.log('====================', apiEndPoint, data);

        return fetcher(
          apiEndPoint,
          fetchGetJSONReqOpts({
            method: 'GET',
            body: JSON.stringify(data),
            headers: { 'content-type': 'application/json' },
            credentials: 'include'
          })
        )
          .then(fetchGetJSONResHandler)
          .then(response => {
            const { profileResponse = {}, serviceRes = {} } = response;
            addCleverTapUserLogin(profileResponse);
            dispatch(setCaptcha(serviceRes.reason));
            dispatch(hideLoader('auth-modal-loader'));
            callback();
          })
          .catch(err => {
            let statusCode = getErrorStatusCode(err);
            errorParser(err, statusCode).then((errorObj = {}) => {
              errorObj.originator = 'login';
              if (errorObj.subject === 'captchaInputRequired') {
                dispatch(setCaptcha(errorObj.reason));
              }
              dispatch(hideLoader('auth-modal-loader'));
              dispatch(setErrorObject(errorObj));
              hideError(dispatch);
            });
          });
      })
      .catch(err => {
        let messageBar = {
          errorType: 'info',
          pageType: 'login-info',
          message: 'oops! something went wrong, please try again...'
        };
        dispatch(setErrorObject(messageBar));
      });
  };
}
export function accountCheckFraudFlow(data, callback) {
  return function (dispatch) {
    return checkFingerPrintDetails()
      .then(() => {
        dispatch(showLoader('auth-modal-loader'));
        const apiEndPoint = loginHostUrl(login_url, '/api/auth/accountCheck');
  
        return fetcher(
          apiEndPoint,
          fetchGetJSONReqOpts({
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'content-type': 'application/json' },
            credentials: 'include'
          })
        )
          .then(fetchGetJSONResHandler)
          .then(serviceRes => {
            console.log('SERVICE RES', serviceRes);
            dispatch(setAccCheckResponse(serviceRes, data));
            if (serviceRes.captchaInputRequired) dispatch(setCaptcha(serviceRes.captchaImage));
            dispatch(setUserInfo(serviceRes));
            dispatch(hideLoader('auth-modal-loader'));
            dispatch(setErrorObject({}));
            callback(serviceRes);
          })
          .catch(err => {
            console.log('ERROR', err);
            let statusCode = getErrorStatusCode(err);
            errorParser(err, statusCode).then((errorObj = {}) => {
              errorObj.originator = 'login';
              dispatch(hideLoader('auth-modal-loader'));
              let messageBar = {
                errorType: 'info',
                pageType: 'login-info',
                message: 'oops! something went wrong, please try again..'
              };
              dispatch(setErrorObject(messageBar));
            });
          });
      })
      .catch(err => {
        let messageBar = {
          errorType: 'info',
          pageType: 'login-info',
          message: 'oops! something went wrong, please try again...'
        };
        dispatch(setErrorObject(messageBar));
      });
  };
}
export function generateCaptchaForRestoreMobile(callback) {
  return function (dispatch) {
    return checkFingerPrintDetails()
      .then(() => {
        dispatch(showLoader('auth-modal-loader'));
        const apiEndPoint = loginHostUrl(login_url, '/api/auth/generate-captcha');
        return fetcher(
          apiEndPoint,
          fetchGetJSONReqOpts({
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            credentials: 'include'
          })
        )
          .then(fetchGetJSONResHandler)
          .then(serviceRes => {
            dispatch(setGenerateCaptchaInfo(serviceRes));
            dispatch(hideLoader('auth-modal-loader'));
            dispatch(setErrorObject({}));
            callback(serviceRes);
          })
          .catch(err => {
            let statusCode = getErrorStatusCode(err);
            errorParser(err, statusCode).then((errorObj = {}) => {
              errorObj.originator = 'login';
              dispatch(hideLoader('auth-modal-loader'));
              let messageBar = {
                errorType: 'info',
                pageType: 'login-info',
                message: 'oops! something went wrong, please try again..'
              };
              dispatch(setErrorObject(messageBar));
            });
          });
      })
      .catch(err => {
        let messageBar = {
          errorType: 'info',
          pageType: 'login-info',
          message: 'oops! something went wrong, please try again...'
        };
        dispatch(setErrorObject(messageBar));
      });
  };
}
export function generateEmailForRestoreMobile(data, callback) {
  return function (dispatch) {
    return checkFingerPrintDetails()
      .then(() => {
        dispatch(showLoader('auth-modal-loader'));
        const apiEndPoint = loginHostUrl(login_url, '/api/auth/generate-email');
        return fetcher(
          apiEndPoint,
          fetchGetJSONReqOpts({
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'content-type': 'application/json' },
            credentials: 'include'
          })
        )
          .then(fetchGetJSONResHandler)
          .then(serviceRes => {
            dispatch(hideLoader('auth-modal-loader'));
            dispatch(setErrorObject({}));
            callback(serviceRes);
          })
          .catch(err => {
            let statusCode = getErrorStatusCode(err);
            errorParser(err, statusCode).then((errorObj = {}) => {
              errorObj.originator = 'login';
              dispatch(hideLoader('auth-modal-loader'));
              let messageBar = {
                errorType: 'info',
                pageType: 'login-info',
                message: 'oops! something went wrong, please try again..'
              };
              dispatch(setErrorObject(messageBar));
            });
          });
      })
      .catch(err => {
        let messageBar = {
          errorType: 'info',
          pageType: 'login-info',
          message: 'oops! something went wrong, please try again...'
        };
        dispatch(setErrorObject(messageBar));
      });
  };
}
export function login(data, callback, catchCallback) {
  return function (dispatch) {
    return checkFingerPrintDetails()
      .then(() => {
        let device;
        let loader;
        if (data.hasOwnProperty('device')) {
          device = data.device;
          delete data.device;
        }
        if (data.hasOwnProperty('loader')) {
          loader = data.loader;
          delete data.loader;
        }
        dispatch(showLoader('auth-modal-loader'));
        const apiEndPoint = loginHostUrl(login_url, '/api/auth/login');
        return fetcher(
          apiEndPoint,
          fetchGetJSONReqOpts({
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'content-type': 'application/json' },
            credentials: 'include'
          })
        )
          .then(fetchGetJSONResHandler)
          .then(response => {
            const { profileResponse = {}, serviceRes = {} } = response;
            addCleverTapUserLogin(profileResponse);
            dispatch(setSignInResponse(serviceRes));

            return Promise.resolve(response);
          })
          .then(async (response) => {
            if (device === 'desktop') {
              return await getCartForUser({ user: data.username, dispatch });
            }
            return Promise.resolve(response);
          })
          .then(response => {
            let userEmailID = readCookie('U') || data.username;
            dispatch(
              setUserInfo({
                userName: readCookie('un') || '',
                emailId: userEmailID
              })
            );
            if (device === 'desktop') {
              let { location: { href = '' } = {} } = window;
              if (loader) dispatch(hideLoader('auth-modal-loader'));
            } else if (loader) dispatch(hideLoader('auth-modal-loader'));

            dispatch(
              getLocaleData(userEmailID, () => {
                segmentTrackUser(response?.profileResponse || {}, {
                  loggedin_status: 'loggedIn',
                  loggedin_type: 'OTP'
                });
                callback(true);
              })
            );
          })
          .catch(err => {
            console.log('error in login', err);
            let statusCode = getErrorStatusCode(err);
            return errorParser(err, statusCode).then((errorObj = {}) => {
            console.log('error object in login', errorObj);
              if (errorObj.redirectToOTP) {
                catchCallback();
                return;
              }
              errorObj.originator = 'login';
              if (errorObj.subject === 'captchaInputRequired') {
                dispatch(setCaptcha(errorObj.reason));
              }
              dispatch(setErrorObject(errorObj));
              if (errorObj.type !== 'FraudUserError') {
                hideError(dispatch);
              }
              callback(false);
              gtmEventPush({
                event: 'login_fail',
                login_method: `password`,
                screen_type: 'login/signup screen',
                error_message: errorObj?.message,
                page_type: 'login page',
                page_name: 'Step 3 | Login Enter Password'
              });
              dispatch(hideLoader('auth-modal-loader'));
            });
          });
      })
      .catch(err => {
        let messageBar = {
          errorType: 'info',
          pageType: 'login-info',
          message: 'oops! something went wrong, please try again...'
        };
        dispatch(setErrorObject(messageBar));
      });
  };
}

export function generateLoginOTP(data, callbackOtp) {
  return function (dispatch) {
    return checkFingerPrintDetails()
      .then(() => {
        dispatch(showLoader('auth-modal-loader'));
        const apiEndPoint = loginHostUrl(login_url, '/api/auth/generateLoginOTP');
        return fetcher(
          apiEndPoint,
          fetchGetJSONReqOpts({
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'content-type': 'application/json' },
            credentials: 'include'
          })
        )
          .then(fetchGetJSONResHandler)
          .then(serviceRes => {
            dispatch(setGenerateLoginOTPResponse(serviceRes));
            dispatch(hideLoader('auth-modal-loader'));
            callbackOtp && callbackOtp();
          })
          .catch(err => {
            let statusCode = getErrorStatusCode(err);
            errorParser(err, statusCode).then((errorObj = {}) => {
              errorObj.originator = 'login';
              dispatch(hideLoader('auth-modal-loader'));
              dispatch(setErrorObject(errorObj));
              hideError(dispatch);
            });
          });
      })
      .catch(err => {
        let messageBar = {
          errorType: 'info',
          pageType: 'login-info',
          message: 'oops! something went wrong, please try again...'
        };
        dispatch(setErrorObject(messageBar));
      });
  };
}

export function fetchEmailByURL(data, callbackVerify) {
  return function (dispatch) {
    return checkFingerPrintDetails()
      .then(() => {
        dispatch(showLoader('auth-modal-loader'));
        const apiEndPoint = loginHostUrl(login_url, '/api/auth/fetchEmailByURL');
        return fetcher(
          apiEndPoint,
          fetchGetJSONReqOpts({
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'content-type': 'application/json' },
            credentials: 'include'
          })
        )
          .then(fetchGetJSONResHandler)
          .then(serviceRes => {
            // dispatch(setGenerateLoginOTPResponse(serviceRes));
            dispatch(hideLoader('auth-modal-loader'));
            callbackVerify && callbackVerify(serviceRes);
          })
          .catch(err => {
            let statusCode = getErrorStatusCode(err);
            errorParser(err, statusCode).then((errorObj = {}) => {
              errorObj.originator = 'login';
              dispatch(hideLoader('auth-modal-loader'));
              dispatch(setErrorObject(errorObj));
              hideError(dispatch);
            });
          });
      })
      .catch(err => {
        let messageBar = {
          errorType: 'info',
          pageType: 'login-info',
          message: 'oops! something went wrong, please try again...'
        };
        dispatch(setErrorObject(messageBar));
      });
  };
}

export function generateOTPForVerify(data, callbackVerify) {
  return function (dispatch) {
    return checkFingerPrintDetails()
      .then(() => {
        dispatch(showLoader('auth-modal-loader'));
        const apiEndPoint = loginHostUrl(login_url, '/api/auth/generateVerifyOTP');
        return fetcher(
          apiEndPoint,
          fetchGetJSONReqOpts({
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'content-type': 'application/json' },
            credentials: 'include'
          })
        )
          .then(fetchGetJSONResHandler)
          .then(serviceRes => {
            // dispatch(setGenerateLoginOTPResponse(serviceRes));
            dispatch(hideLoader('auth-modal-loader'));
            callbackVerify && callbackVerify(serviceRes);
          })
          .catch(err => {
            let statusCode = getErrorStatusCode(err);
            errorParser(err, statusCode).then((errorObj = {}) => {
              callbackVerify && callbackVerify({ success: false, ...errorObj });
              errorObj.originator = 'login';
              dispatch(hideLoader('auth-modal-loader'));
              dispatch(setErrorObject(errorObj));
              hideError(dispatch);
            });
          });
      })
      .catch(err => {
        let messageBar = {
          errorType: 'info',
          pageType: 'login-info',
          message: 'oops! something went wrong, please try again...'
        };
        dispatch(setErrorObject(messageBar));
      });
  };
}

export function verifyOTPForUpdateMobileNumber(data, callbackVerify) {
  return function (dispatch) {
    return checkFingerPrintDetails()
      .then(() => {
        dispatch(showLoader('auth-modal-loader'));
        const apiEndPoint = loginHostUrl(login_url, '/api/auth/verifyUpdateMobileNumberOTP');
        return fetcher(
          apiEndPoint,
          fetchGetJSONReqOpts({
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'content-type': 'application/json' },
            credentials: 'include'
          })
        )
          .then(fetchGetJSONResHandler)
          .then(serviceRes => {
            // dispatch(setGenerateLoginOTPResponse(serviceRes));
            dispatch(hideLoader('auth-modal-loader'));
            callbackVerify && callbackVerify(serviceRes);
          })
          .catch(err => {
            let statusCode = getErrorStatusCode(err);
            console.log(err, 'err line 643');
            errorParser(err, statusCode).then((errorObj = {}) => {
              const errMsg = errorObj?.errorMessage?.errors && errorObj?.errorMessage?.errors[0]?.message;
              const errMessage = errorObj?.errorMessage?.message;
              const message = errMsg || errMessage || errorObj.message;
              callbackVerify && callbackVerify({ success: false, message });
              errorObj.originator = 'login';
              dispatch(hideLoader('auth-modal-loader'));
              // dispatch(setErrorObject(errorObj));
              hideError(dispatch);
            });
          });
      })
      .catch(err => {
        let messageBar = {
          errorType: 'info',
          pageType: 'login-info',
          message: 'oops! something went wrong, please try again...'
        };
        dispatch(setErrorObject(messageBar));
      });
  };
}

export function setNewPassword(data, callbackNewPwd) {
  return function (dispatch) {
    dispatch(showLoader('auth-modal-loader'));
    const apiEndPoint = loginHostUrl(login_url, '/api/auth/setNewPassword');
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(serviceRes => {
        dispatch(setNewPasswordResponse(serviceRes));
        // dispatch(hideLoader("auth-modal-loader"));
        callbackNewPwd(serviceRes);
        return Promise.resolve(serviceRes);
      })
      .catch(err => {
        let statusCode = getErrorStatusCode(err);
        return errorParser(err, statusCode).then((errorObj = {}) => {
          errorObj.originator = 'login';
          dispatch(hideLoader('auth-modal-loader'));
          dispatch(setErrorObject(errorObj));
          hideError(dispatch);
          return Promise.reject(errorObj);
        });
      });
  };
}

export function socialAuth(data, callback, device, catchCallback) {
  return async function (dispatch) {
    dispatch(showLoader('auth-modal-loader'));
    const apiEndPoint = loginHostUrl(login_url, '/api/auth/socialAuth');
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const { profileResponse = {}, serviceRes = {} } = response;
        addCleverTapUserLogin(profileResponse);
        // segmentTrackUser(profileResponse,{ loggedin_status:'loggedIn', loggedin_type: 'socialAuth'});
        dispatch(setSocialSignInResponse(serviceRes));
        dispatch(hideLoader('auth-modal-loader'));
        let userEmailID = readCookie('U') || data.login;
        dispatch(
          getLocaleData(userEmailID, () => {
            segmentTrackUser(response?.profileResponse || {}, {
              loggedin_status: 'loggedIn',
              loggedin_type: 'socialAuth'
            });
          })
        );
        if (device === 'desktop') {
          return getCartForUser({ user: data.login, dispatch }).then(() => {
            callback && callback(serviceRes);
            return Promise.resolve(serviceRes);
          });
        }
        callback && callback(serviceRes);
        return Promise.resolve(serviceRes);
      })
      .catch(err => {
        let statusCode = getErrorStatusCode(err);
        return errorParser(err, statusCode).then((errorObj = {}) => {
          if (errorObj.redirectToOTP) {
            if (catchCallback) {
              dispatch(hideLoader('auth-modal-loader'));
              return catchCallback();
            }
          }
          errorObj.originator = 'login';
          dispatch(hideLoader('auth-modal-loader'));
          dispatch(setErrorObject(errorObj));
          hideError(dispatch);
          callback && callback(err);
          return Promise.reject(err);
        });
      });
  };
}

export function fbSignIn() {
  return function (dispatch) { };
}

export function signout(callback) {
  return function (dispatch) {
    dispatch && dispatch(showLoader('auth-modal-loader'));
    const apiEndPoint = loginHostUrl(login_url, '/api/auth/signout');
    if (!isNode()) {
      return fetcher(
        apiEndPoint,
        fetchGetJSONReqOpts({
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          credentials: 'include'
        })
      )
        .then(fetchGetJSONResHandler)
        .then(serviceRes => {
          sessionStorage.removeItem('ActivityToastMessage');
          sessionStorage.removeItem('customerTypeData');
          sessionStorage.removeItem('cross_sell_add_to_bag_animation_seen');
          localStorage.removeItem('customerTypeData');
          localStorage.removeItem('companion_flow_data');
          //  eraseCookie('affiliate_tracking');
          // successful_referrals lives until logout only
          clearAmplitudeReferralProps();
          setCookie('pincode', '');
          const persistedState = JSON.parse(localStorage.getItem('persist:root'));
            if (persistedState) {
              delete persistedState.addressBook;
              delete persistedState.fleek;
              localStorage.setItem('persist:root', JSON.stringify(persistedState));
            }
          dispatch && dispatch(hideLoader('auth-modal-loader'));
          callback();
          gtmEventPush({
            page_type: 'My account screen',
            event: 'user_account_interactions',
            event_category: 'user accounts interactions',
            action: 'logout successful'
          });
          // Segment Push Event

          segmentEventPush({
            event: 'Logout Clicked',
            logout_status: 'success',
            screen_name: 'user sign out'
          });

          try {
            amplitudeLogout();
            segmentReset();
            eraseCookie('segment_user_id');
            eraseCookie('LS');
          } catch (e) {
            console.log(e);
          }
        })
        .catch(err => {
          let statusCode = getErrorStatusCode(err);
          errorParser(err, statusCode).then((errorObj = {}) => {
            errorObj.originator = 'login';
            if (dispatch) {
              dispatch(hideLoader('auth-modal-loader'));
              dispatch(setErrorObject(errorObj));
              hideError(dispatch);
            }
            callback();
            gtmEventPush({
              page_type: 'My account screen',
              event: 'user_account_interactions',
              event_category: 'user accounts interactions',
              action: 'logout Failure',
              label: errorObj.message
            });
          });
        });
    }
  };
}

export function promptUserForEmployeeId(callback) {
  return dispatch => {
    dispatch(showLoader('layout-loader'));
    let pendingOrder = readCookie('PO');
    if (typeof pendingOrder == 'string') {
      pendingOrder = JSON.parse(decodeURIComponent(pendingOrder));
    }
    if (pendingOrder && pendingOrder.length > 0) {
      dispatch(hideLoader('layout-loader'));
      dispatch(setLayoutModalContent());
    } else {
      signout(callback)(dispatch);
    }
  };
}

export function submitAndSignOut({
  callback,
  employeeId = '',
  logout = true,
  client = true,
  req = {}
}) {
  return dispatch => {
    client && dispatch(showLoader('layout-loader'));
    let apiEndPoint = '/api/auth/submit-assistant-id';
    if (!client) {
      let { headers: { host = '' } = {} } = req;
      apiEndPoint = `http://${host}/api/auth/submit-assistant-id`;
    }
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ employeeId, logout, clearPOCookie: client })
      })
    )
      .then(fetchGetJSONResHandler)
      .then(serviceRes => {
        client && dispatch(hideLoader('layout-loader'));
        callback && callback();
      })
      .catch(err => {
        let statusCode = getErrorStatusCode(err);
        errorParser(err, statusCode).then((errorObj = {}) => {
          client && dispatch(hideLoader('layout-loader'));
          dispatch(setErrorObject(errorObj));
          hideError(dispatch);
        });
      });
  };
}

export function loginForKiosk(data, callback) {
  let { username = '', otp = '', kiosk = true } = data;
  let accCheckResponse = {};
  return dispatch => {
    dispatch(showLoader('layout-loader'));
    return accountCheck({ mobileNumber: username }, response => {
      accCheckResponse = response;
    })(dispatch).then(() => {
      let { success } = accCheckResponse;
      /**
       * If Success then existing user then call
       *  loginmethod
       */
      if (success) {
        login({ username, otp, kiosk: true }, () => {
          callback();
          dispatch(hideLoader('layout-loader'));
        })(dispatch);
      } else {
        registerKioskUser({ mobileNumber: username, kiosk: true, otp }, dispatch, () => {
          callback();
          dispatch(hideLoader('layout-loader'));
        });
      }
    });
  };
}

function registerKioskUser(data, dispatch, callback) {
  return fetcher(
    '/api/auth/kiosk-create-user',
    fetchGetJSONReqOpts({
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(data)
    })
  )
    .then(fetchGetJSONResHandler)
    .then(response => {
      callback();
    })
    .catch(err => {
      let statusCode = getErrorStatusCode(err);
      errorParser(err, statusCode).then((errorObj = {}) => {
        dispatch(hideLoader('layout-loader'));
        dispatch(setErrorObject(errorObj));
        hideError(dispatch);
      });
    });
}

export function ssoCheck(ssoToken = '') {
  return dispatch => {
    let bodyVal = {
      token: ssoToken
    };
    dispatch(showLoader('cart-loader'));
    return fetcher(
      '/api/auth/sso-check',
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(bodyVal)
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        if (response.statusCode == 2) {
          dispatch(hideLoader('cart-loader'));
          dispatch(setSSOCheckResponse(response));
          return Promise.resolve(response);
        } else {
          console.log('error', response);
          dispatch(hideLoader('cart-loader'));
          return Promise.reject({});
        }
      })
      .catch(error => {
        console.log('error', error);
        dispatch(hideLoader('cart-loader'));
        return Promise.reject(error);
      });
  };
}

export function ssoLogin(ssoData) {
  return dispatch => {
    let { registeredUser = '', mobileNo = '' } = ssoData;
    if (!registeredUser) {
      dispatch(showLoader('cart-loader'));
      return fetcher(
        '/api/auth/sso-register',
        fetchGetJSONReqOpts({
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ ssoData })
        })
      )
        .then(fetchGetJSONResHandler)
        .then(response => {
          // console.log("val", response);
          dispatch(hideLoader('cart-loader'));
          dispatch(setSignInResponse(response));
          return Promise.resolve(response);
        })
        .catch(error => {
          console.log('error', error);
          dispatch(hideLoader('cart-loader'));
          return Promise.reject(error);
        });
    } else {
      dispatch(showLoader('cart-loader'));
      return fetcher(
        '/api/auth/sso-login',
        fetchGetJSONReqOpts({
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ mobileNo })
        })
      )
        .then(fetchGetJSONResHandler)
        .then(response => {
          // console.log("val", response);
          dispatch(hideLoader('cart-loader'));
          dispatch(setSignInResponse(response));
          return Promise.resolve(response);
        })
        .catch(error => {
          console.log('error', error);
          dispatch(hideLoader('cart-loader'));
          return Promise.reject(error);
        });
    }
  };
}

export function accountCheckFraud(data, callback) {
  return function (dispatch) {
    return checkFingerPrintDetails()
      .then(() => {
        dispatch(showLoader('auth-modal-loader'));
        const apiEndPoint = loginHostUrl(login_url, '/api/auth/accountCheck');
        return fetcher(
          apiEndPoint,
          fetchGetJSONReqOpts({
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'content-type': 'application/json' },
            credentials: 'include'
          })
        )
          .then(fetchGetJSONResHandler)
          .then(serviceRes => {
            dispatch(setAccCheckResponse(serviceRes, data));
            if (serviceRes.captchaInputRequired) dispatch(setCaptcha(serviceRes.captchaImage));
            dispatch(setUserInfo(serviceRes));
            dispatch(hideLoader('auth-modal-loader'));
            dispatch(setErrorObject({}));
            callback(serviceRes);
          })
          .catch(err => {
            let statusCode = getErrorStatusCode(err);
            errorParser(err, statusCode).then((errorObj = {}) => {
              errorObj.originator = 'login';
              dispatch(hideLoader('auth-modal-loader'));
              let messageBar = {
                errorType: 'info',
                pageType: 'login-info',
                message: 'oops! something went wrong, please try again..'
              };
              dispatch(setErrorObject(messageBar));
            });
          });
      })
      .catch(err => {
        let messageBar = {
          errorType: 'info',
          pageType: 'login-info',
          message: 'oops! something went wrong, please try again...'
        };
        dispatch(setErrorObject(messageBar));
      });
  };
}
